export default "__VITE_ASSET__ksCloVtT__"